<template>
  <div>
    <div class="section-title mb-10">{{ $t('text.font_family') }}</div>
    <font-picker
      :api-key="apiKey"
      :active-font="activeFont"
      @change="changeFont"
    ></font-picker>
    <el-divider></el-divider>
    <div class="section-title mb-10">{{ $t('text.font_size') }}</div>
    <el-form :model="fontSizeForm" :inline="true">
      <el-form-item :label="$t('text.main_title')" prop="mainTitle">
        <el-select
          v-model="fontSizeForm.mainTitle"
          :placeholder="$t('text.select')"
        >
          <el-option
            v-for="item in fontSizeOptions"
            :key="'mainTitle' + item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('text.title')" prop="title">
        <el-select
          v-model="fontSizeForm.title"
          :placeholder="$t('text.select')"
          @change="changeFontSize"
        >
          <el-option
            v-for="item in fontSizeOptions"
            :key="'title' + item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('text.small_title')" prop="smallTitle">
        <el-select
          v-model="fontSizeForm.smallTitle"
          :placeholder="$t('text.select')"
          @change="changeFontSize"
        >
          <el-option
            v-for="item in fontSizeOptions"
            :key="'smallTitle' + item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('text.body_text')" prop="bodyText">
        <el-select
          v-model="fontSizeForm.bodyText"
          :placeholder="$t('text.select')"
          @change="changeFontSize"
        >
          <el-option
            v-for="item in fontSizeOptions"
            :key="'bodyText' + item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('text.body_text_small')" prop="bodyTextSmall">
        <el-select
          v-model="fontSizeForm.bodyTextSmall"
          :placeholder="$t('text.select')"
          @change="changeFontSize"
        >
          <el-option
            v-for="item in fontSizeOptions"
            :key="'bodyTextSmall' + item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('text.supplementary_text')"
        prop="supplementaryText"
      >
        <el-select
          v-model="fontSizeForm.supplementaryText"
          :placeholder="$t('text.select')"
          @change="changeFontSize"
        >
          <el-option
            v-for="item in fontSizeOptions"
            :key="'supplementaryText' + item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-divider></el-divider>
    <div class="section-title mb-10">{{ $t('text.font_color') }}</div>
    <el-form :model="fontColorForm" :inline="true">
      <el-form-item :label="$t('text.primary_text')" prop="primaryText">
        <el-color-picker
          v-model="fontColorForm.primaryText"
          @change="changeFontColor"
        ></el-color-picker>
      </el-form-item>
      <el-form-item :label="$t('text.regular_text')" prop="regularText">
        <el-color-picker
          v-model="fontColorForm.regularText"
          @change="changeFontColor"
        ></el-color-picker>
      </el-form-item>
      <el-form-item :label="$t('text.secondary_text')" prop="secondaryText">
        <el-color-picker
          v-model="fontColorForm.secondaryText"
          @change="changeFontColor"
        ></el-color-picker>
      </el-form-item>
      <el-form-item :label="$t('text.placeholder_text')" prop="placeholderText">
        <el-color-picker
          v-model="fontColorForm.placeholderText"
          @change="changeFontColor"
        ></el-color-picker>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Vue from 'vue'
import FontPicker from 'font-picker-vue'
Vue.use(FontPicker)
export default {
  data() {
    return {
      apiKey: 'AIzaSyAWQFWJL1jFQ4gs7aQtWwM1gvWq3ZMbdPM',
      activeFont: 'RobotoCondensed',
      fontSizeForm: {
        mainTitle: 26,
        title: 18,
        smallTitle: 17,
        bodyText: 16,
        bodyTextSmall: 14,
        supplementaryText: 13
      },
      fontSizeOptions: [
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30
      ],
      fontColorForm: {
        primaryText: '#000000',
        regularText: '#333333',
        secondaryText: '#555555',
        placeholderText: '#c0c4cc'
      }
    }
  },
  components: {
    FontPicker
  },
  mounted() {
    if (this.$store.state.customization.font) {
      this.activeFont = this.$store.state.customization.font
    }
    if (this.$store.state.customization.fontSize) {
      this.fontSizeForm = this.$store.state.customization.fontSize
    }
    if (this.$store.state.customization.fontColor) {
      this.fontColorForm = this.$store.state.customization.fontColor
    }
  },
  methods: {
    changeFont(params) {
      this.activeFont = params.family
      this.$store.dispatch('customization/applyFont', this.activeFont)
    },
    changeFontSize() {
      this.$store.dispatch('customization/applyFontSize', this.fontSizeForm)
    },
    changeFontColor() {
      this.$store.dispatch('customization/applyFontColor', this.fontColorForm)
    }
  }
}
</script>
